<template>
  <div class="voz-guideline-transparent-content" id="identidade-verbal-voz-transparente-e-contundente" data-search-anchor>
    <h1 class="voz-guideline-transparent-title">{{ vozGuidelineTransparentTitle }}</h1>
    <p class="voz-guideline-transparent-paragraph">{{ vozGuidelineTransparentParagraph }}</p>

    <div class="voz-guideline-transparent-wrapper">
      <div
        class="voz-guideline-transparent-container-img"
        :style="{ backgroundImage: `url(${vozGuidelineTransparentImageSrc})` }"
      >
        <div class="voz-guideline-transparent-overlay">
          <h1 class="voz-guideline-transparent-number">4</h1>

          <div class="voz-guideline-transparent-content-text">
            <h3 class="voz-guideline-transparent-card-title">
              {{ vozGuidelineTransparentCardTitle }}
            </h3>

            <p class="voz-guideline-transparent-text">
              {{ vozGuidelineTransparentText }}
            </p>
          </div>
        </div>
      </div>

      <div class="voz-guideline-transparent-column">
        <div class="voz-transparent-icon-paragraph-title">
          <IconCheck />
          <h1 class="voz-guideline-transparent-prefer-paragraph-title">
            {{ vozGuidelineTransparentParagraphPref }}               
          </h1>
        </div>
        <p class="voz-guideline-transparent-prefer-paragraph">{{ vozGuidelinePreferParagraph1 }}</p>
        <p class="voz-guideline-transparent-prefer-paragraph">{{ vozGuidelinePreferParagraph2 }}</p>
        <p class="voz-guideline-transparent-prefer-paragraph">{{ vozGuidelinePreferParagraph3 }}</p>
        

         <div class="voz-transparent-icon-paragraph-title" style="margin-top: 58px;">
          <IconCancel />
          <h1 class="voz-guideline-transparent-prefer-paragraph-title">
            {{ vozGuidelineTransparentParagraphEvit }}
          </h1>
        </div>
        <p class="voz-guideline-transparent-prefer-paragraph">{{ vozGuidelineEvitParagraph5 }}</p>        
        <p class="voz-guideline-transparent-prefer-paragraph">{{ vozGuidelineEvitParagraph6 }}</p>
        <p class="voz-guideline-transparent-prefer-paragraph">{{ vozGuidelineEvitParagraph7 }}</p>        
      </div>

      <div class="gap-col"></div>

      <div class="voz-guideline-transparent-column">
        <div class="voz-transparent-icon-paragraph-title">
          <IconCheck />
          <h1 class="voz-guideline-transparent-prefer-paragraph-title">
            {{ vozGuidelineTransparentParagraphExempl }}
          </h1>
        </div>
        <p class="voz-guideline-transparent-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit1 }}</p>
        <p class="voz-guideline-transparent-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit2 }}</p>        

        <div class="voz-transparent-icon-paragraph-title" style="margin-top: 72px;">
          <IconCancel />
          <h1 class="voz-guideline-transparent-prefer-paragraph-title">
            {{ vozGuidelineTransparentParagraphExempl2 }}
          </h1>
        </div>
        <p class="voz-guideline-transparent-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit3 }}</p>              
        <p class="voz-guideline-transparent-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit4 }}</p>
        <p class="voz-guideline-transparent-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit5 }}</p>
        <p class="voz-guideline-transparent-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit6 }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VozPageMixin from '@/mixins/voz-page-mixin'
import { VozPageStore } from '@/store/verbal-identity-page/voz-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck, IconCancel } })
export default class VozGuidelineTransparentSection extends Mixins(VozPageMixin) {
  vozPageStore: PageStoreContract = getModule(VozPageStore, this.$store)

  get vozGuidelineTransparentTitle(): string {
    return this.getElementTitle(7, 0)
  }

  get vozGuidelineTransparentParagraph(): string {
    return this.getElementText(7, 1)
  }

  get vozGuidelineTransparentImageSrc(): string {
    return this.getElementMedia(7, 2)
  }

  get vozGuidelineTransparentCardTitle(): string {
    return this.getElementTitle(3, 9)
  }

  get vozGuidelineTransparentText(): string {
    return this.getElementText(3, 9)
  }

  //colum pref
  get vozGuidelineTransparentParagraphPref(): string {
    return this.getElementTitle(7, 3)
  } 
  
  get vozGuidelinePreferParagraph1(): string {
    return this.getElementText(7, 3)
  }

  get vozGuidelinePreferParagraph2(): string {
    return this.getElementText(7, 4)
  }

  get vozGuidelinePreferParagraph3(): string {
    return this.getElementText(7, 5)
  }
  
  //colum evit
  get vozGuidelineTransparentParagraphEvit(): string {
    return this.getElementTitle(7, 6)
  }
  
  get vozGuidelineEvitParagraph5(): string {
    return this.getElementText(7, 6)
  }

  get vozGuidelineEvitParagraph6(): string {
    return this.getElementText(7, 7)
  }

  get vozGuidelineEvitParagraph7(): string {
    return this.getElementText(7, 8)
  }   

  //colum exempl
  get vozGuidelineTransparentParagraphExempl(): string {
    return this.getElementTitle(7, 9)
  }  

  get vozGuidelineExemplParagraphEvit1(): string {
    return this.getElementText(7, 9)
  }

  get vozGuidelineExemplParagraphEvit2(): string {
    return this.getElementText(7, 10)
  }

 
   
  //colum exempl2
  get vozGuidelineTransparentParagraphExempl2(): string {
    return this.getElementTitle(7, 11)
  }

   get vozGuidelineExemplParagraphEvit3(): string {
    return this.getElementText(7, 11)
  }

  get vozGuidelineExemplParagraphEvit4(): string {
    return this.getElementText(7, 12)
  }

  get vozGuidelineExemplParagraphEvit5(): string {
    return this.getElementText(7, 13)
  }

  get vozGuidelineExemplParagraphEvit6(): string {
    return this.getElementText(7, 14)
  }

  async getVozPage(): Promise<void> {
    await this.vozPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.vozPageStore.isLoading) {
      await this.getVozPage()
    }
  }
}
</script>

<style lang="scss">
.voz-guideline-transparent-content {
  display: grid;
  justify-content: center;
  margin-top: 150px;  
  max-width: 1032px;
}

.voz-guideline-transparent-title {
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: center;
  width: 976px;
  margin: 0 auto;
}

.voz-guideline-transparent-paragraph {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  width: 503px;
  margin: 0 auto;
  margin-top: 49px;
}

.voz-guideline-transparent-wrapper {
  display: grid;
  grid-template-columns: 369px 307px 50px 307px;
  width: 1032px;
  margin: 0 auto;
  margin-top: 148px;
  margin-bottom: 48px;
}

.voz-guideline-transparent-container-img {
  width: 341px;
  height: 681px;
  border-radius: 16px;
  overflow: hidden;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  position: relative;
}

.voz-guideline-transparent-overlay {
  position: absolute;
  inset: 0;

  padding: 24px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  color: #fff;
}

.voz-guideline-transparent-number {
  font-size: 267px;
  font-weight: 600;
  margin: 0;
}

.voz-guideline-transparent-content-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.voz-guideline-transparent-card-title {
  font-family: GlobotipoCorporativaRegular;
  font-size: 28px;
  font-weight: 400;
  width: 170px;
  margin: 0;
}

.voz-guideline-transparent-text {
  font-family: GlobotipoCorporativaTextosRegular;
  font-size: 18px;
  width: 200px;
  margin: 0;
}

.voz-guideline-transparent-column {
  display: flex;
  flex-direction: column;
}

.voz-transparent-icon-paragraph-title {
  display: flex;
  align-items: center;
  gap: 8px;  
}

.voz-guideline-transparent-prefer-paragraph-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 36px;
}

.voz-guideline-transparent-prefer-paragraph,
.voz-guideline-transparent-exempl-paragraph {
  margin-top: 0;  
}

.voz-guideline-transparent-prefer-paragraph,
.voz-guideline-transparent-exempl-paragraph{
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.voz-guideline-transparent-exempl-paragraph:nth-last-of-type(2){
  white-space: pre-wrap;
}
</style>
